import { useApi } from '../hooks/useApi.js';
import { fetchGalleryAlbums, fetchGalleryAlbum } from '../lib/api.js';
import { Seo } from '../components/Seo.jsx';
import { PageHeader } from '../components/PageHeader.jsx';
import { Gallery } from '../components/Gallery.jsx';
import { usePage } from '../hooks/usePage.js';

const FALLBACK_TILES = [
  { id: 'f1',  image: 'https://images.unsplash.com/photo-1497486751825-1233686d5d80?w=1600&q=80', tileSize: 'wide' },
  { id: 'f2',  image: 'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=900&q=80' },
  { id: 'f3',  image: 'https://images.unsplash.com/photo-1517649763962-0c623066013b?w=900&q=80' },
  { id: 'f4',  image: 'https://images.unsplash.com/photo-1532094349884-543bc11b234d?w=900&q=80' },
  { id: 'f5',  image: 'https://images.unsplash.com/photo-1568667256549-094345857637?w=900&q=80', tileSize: 'tall' },
  { id: 'f6',  image: 'https://images.unsplash.com/photo-1523240795612-9a054b0db644?w=900&q=80' },
  { id: 'f7',  image: 'https://images.unsplash.com/photo-1571260899304-425eee4c7efc?w=900&q=80' },
  { id: 'f8',  image: 'https://images.unsplash.com/photo-1521587760476-6c12a4b040da?w=900&q=80' },
  { id: 'f9',  image: 'https://images.unsplash.com/photo-1509062522246-3755977927d7?w=1600&q=80', tileSize: 'wide' },
  { id: 'f10', image: 'https://images.unsplash.com/photo-1466637574441-749b8f19452f?w=900&q=80' },
  { id: 'f11', image: 'https://images.unsplash.com/photo-1581092580497-e0d23cbdf1dc?w=900&q=80' },
];

export function PhotosPage() {
  const head = usePage('photos');
  const { data: albums } = useApi(fetchGalleryAlbums, []);
  const firstSlug = albums?.[0]?.slug;
  const { data: album } = useApi(
    () => firstSlug ? fetchGalleryAlbum(firstSlug) : Promise.resolve(null),
    [firstSlug],
  );

  const images = album?.images?.length ? album.images : FALLBACK_TILES;

  return (
    <>
      <Seo title="Photos" description={head.metaDescription} />

      <PageHeader
        crumbs={[{ label: 'Home', to: '/' }, { label: 'Media & News' }, { label: 'Photos' }]}
        headline={head.headline}
        lede={head.lede}
        image={head.banner}
      />

      <section>
        <div className="container">
          <Gallery images={images} />
        </div>
      </section>
    </>
  );
}
